<script>
export default {
  name: 'DonationStarter',
  props: {
    cookiename: {
      type: String,
      required: true,
    },
    defaultdonationsingleamount: {
      type: String,
      required: true,
    },
    defaultdonationmonthlyamount: {
      type: String,
      required: true,
    },
    donationsingleamountone: {
      type: Number,
      required: true,
    },
    donationsingleamounttwo: {
      type: Number,
      required: true,
    },
    donationsingleamountthree: {
      type: Number,
      required: true,
    },
    donationmonthlyamountone: {
      type: Number,
      required: true,
    },
    donationmonthlyamounttwo: {
      type: Number,
      required: true,
    },
    donationmonthlyamountthree: {
      type: Number,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
    idtypesingle: {
      type: String,
      required: true,
    },
    idtypemonthly: {
      type: String,
      required: true,
    },
    singlelabel: {
      type: String,
      required: true,
    },  
    monthlylabel: {
      type: String,
      required: true,
    },
    submitlabel: {
      type: String,
      required: true,
    },
    errormessage: {
      type: String,
      required: true,
    },
    partialpath: {
      type: String,
      required: true,
    },
    otheramounttext: {
      type: String,
      required: true,
    },
    checkformonthly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // Donation form IDs - ADMIN inputable
      donationForm: {
        idTypeSingle: this.idtypesingle,
        idTypeMonthly: this.idtypemonthly,
      },

      // donation type ADMIN inputable
      issingledonation: (this.checkformonthly == true) ? false: true,
      //Single/Monthly button labels
      singleButtonCta: this.singlelabel,
      monthlyButtonCta: this.monthlylabel,
      // pre-defined amounts ADMIN inputable
      // EMPTY value = no preference
      // must match one of the other values
      activeValueSingle: (this.defaultdonationsingleamount == "3") ? this.donationsingleamountthree : (this.defaultdonationsingleamount == "2") ? this.donationsingleamounttwo: this.donationsingleamountone,
      activeValueMonthly: (this.defaultdonationmonthlyamount == "3") ? this.donationmonthlyamountthree : (this.defaultdonationmonthlyamount == "2") ?this.donationmonthlyamounttwo:this.donationmonthlyamountone,
      
      // language detection
      isFrenchLanguage: this.language == "fr" ? true : false, 
      
      // Donation values ADMIN inputable
      values: [
        {
          id: 'valueOne',
          labelAmount: this.donationsingleamountone,
          labelAmountMo: this.donationmonthlyamountone,
        },
        {
          id: 'valueTwo',
          labelAmount: this.donationsingleamounttwo,
          labelAmountMo: this.donationmonthlyamounttwo,
        },
        {
          id: 'valueThree',
          labelAmount: this.donationsingleamountthree,
          labelAmountMo: this.donationmonthlyamountthree,
        },
      ],
      
      //Custom donation values
      customValue: {
        singleAmount: '',
        monthlyAmount: '',
        isCustomButtomVisible: true,
        idSingle: 'customSingleId',
        idMonthly: 'customMonthlyId',
      },
      
      //Single/Monthly button labels
      singleButtonCta: this.singlelabel,
      monthlyButtonCta: this.monthlylabel,
      
      // Submit Button ADMIN inputable
      submitButtonCta: this.submitlabel,
      submitTarget: '_new',
      submitUrl: this.submitDonationUrl,
            
      languageForm: '&s_locale=en_CA',

      trackingCookie: '&clickedElement=' + this.cookiename + '_' + this.partialpath.replace(/\/+$/, ''),

      donationAmt: 0,

      errors: {
        genericErrorMessage: this.errormessage,
      },
    };
  },
  mounted() {
    this.startHeartbeat();
  },
  methods: {
    startHeartbeat() {
      document.querySelector('.donation-starter__type-button--monthly').classList.add('btn__heartbeat');
      setTimeout(() => document.querySelector('.donation-starter__type-button--monthly').classList.remove('btn__heartbeat'), 6000);
    },
    setDonationSingle() {
      this.issingledonation = true;
      activeValueSingle: (this.defaultdonationsingleamount == "3") ? this.donationsingleamountthree : (this.defaultdonationsingleamount == "2") ? this.donationsingleamounttwo: this.donationsingleamountone;
    },
    setDonationMonthly() {
      this.issingledonation = false;
      activeValueMonthly: (this.defaultdonationmonthlyamount == "3") ? this.donationmonthlyamountthree : (this.defaultdonationmonthlyamount == "2") ?this.donationmonthlyamounttwo:this.donationmonthlyamountone;
    },
    preventNonNumeric(event) {
      // prevent '.' or if there is already a '.' or '.' would be the first character
      if (this.isFrenchLanguage) {
        if (event.key === ',' && (event.target.value.includes(',') || event.target.value.includes('.') || event.target.value === '')) {
          event.preventDefault();
        }
        if (event.key === '.' && (event.target.value.includes(',') || event.target.value.includes('.') || event.target.value === '')) {
          event.preventDefault();
        }
        if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ',', '.'].includes(event.key)) {
          event.preventDefault();
        }
      } 
      else 
      {
        if (event.key === '.' && (event.target.value.includes('.') || event.target.value === '')) {
        event.preventDefault();
        }
        if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'].includes(event.key)) {
          event.preventDefault();
        }
      }
    },
    goToDonationForm() {
      this.errors = [];
      if (this.issingledonation == true) {
        this.donationAmt = this.activeValueSingle;
      }
      else {
        this.donationAmt = this.activeValueMonthly;
      } 
      this.donationAmt= this.donationAmt.replace(",", ".");
      if (this.donationAmt <= 0 || this.donationAmt > 10000) {
        this.errors.push(this.errormessage);
        return;
      }
      if (this.isFrenchLanguage) {
        this.languageForm = "&s_locale=fr_CA"; 
      }
      window.open(this.submitDonationUrl, this.submitTarget);
    },
  },
  computed: {
    submitDonationUrl() {
      if (this.issingledonation == true) { 
        return `https://support.cancer.ca/site/Donation2?df_id=`
        + this.donationForm.idTypeSingle
        + `&mfc_pref=T&`
        + this.donationForm.idTypeSingle
        + `.donation=form1&set.Value=`
        + parseFloat(this.donationAmt).toFixed(2)
        + this.languageForm
        + '&' + this.trackingCookie
      } else {
        return 'https://support.cancer.ca/site/Donation2?df_id='
        + this.donationForm.idTypeMonthly
        + '&mfc_pref=T&'
        + this.donationForm.idTypeMonthly
        + '.donation=form1&set.Value='
        + parseFloat(this.donationAmt).toFixed(2)
        + this.languageForm
        + '&' + this.trackingCookie
      }
    },
    hideCustomAmountButton() {
      this.customValue.isCustomButtomVisible = !this.customValue.isCustomButtomVisible;
    },
  },
};
</script>
<template>
  <div 
    :aria-label="isFrenchLanguage ? 'Assistant de don' : 'Donation helper'" 
    class="donation-starter"
    role="dialog"
  >
    <div class="donation-starter__container">
      <!-- Donation type -->
      <div class="donation-starter__group" id="DonationType">
        <div class="donation-starter__type-container">
          <button 
            :aria-label="(isFrenchLanguage ? 'Sélectionner ' : 'Select ') + singleButtonCta"
            class="donation-starter__type-button donation-starter__type-button--single"
            :class="{'is-active': issingledonation == true}"
            role="button"
            @click="setDonationSingle()"
          >
            <span>{{ singleButtonCta }}</span>
          </button>
        </div>
        <div class="donation-starter__type-container">
          <button 
            :aria-label="(isFrenchLanguage ? 'Sélectionner ' : 'Select ') + monthlyButtonCta"
            class="donation-starter__type-button donation-starter__type-button--monthly"
            :class="{'is-active': issingledonation == false || issingledonation == undefined}"
            role="button"
            @click="setDonationMonthly()"
          > 
            <span>{{ monthlyButtonCta }}</span> 
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><path d="M26.3 5.2c-2.7-2.9-7.1-2.9-9.9-.3l-.3.3L15 6.3l-1.1-1.2C12.6 3.8 10.7 3 8.8 3S5 3.8 3.7 5.2C.9 8.1.9 12.8 3.7 15.7l10.4 11c.2.3.5.4.8.4s.6-.1.8-.4l.1-.1 10.4-11c2.9-2.8 2.9-7.5.1-10.4z" class="donation-inside"></path><path d="M27.7 4c-3-3.2-8-3.3-11.1-.3l-.3.3L15 5.3 13.8 4c-1.5-1.6-3.6-2.4-5.7-2.4-2.2-.1-4.3.8-5.8 2.4-3.1 3.3-3.1 8.5 0 11.8L14 28.1c.2.3.6.4.9.4s.7-.1.9-.4l.1-.1 11.7-12.3c3.2-3.2 3.2-8.4.1-11.7zm-1.9 10L15 25.2 4.2 14a5.92 5.92 0 0 1 0-8.2c.9-1 2.2-1.6 3.6-1.7H8c1.5 0 2.8.6 3.8 1.7L14 8.1c.2.3.6.4.9.4s.7-.1.9-.4l.1-.1 2.2-2.3c1.9-2.1 5.2-2.3 7.3-.3l.3.3c2.2 2.4 2.2 6 .1 8.3z"></path></svg>
          </button>
        </div>
      </div>
      
      <!-- Donation Values -->
      <div class="donation-starter__group" id="AmountButtons">
        
        <!-- Donation SINGLE -->
        <div v-if="issingledonation == true" class="donation-starter__values-wrapper">
          <div v-for="value in values" :key="value.id" class="donation-starter__value-container">
            <button
              :aria-label="isFrenchLanguage ? 'Sélectionner ' + value.labelAmount + ' $' : 'Select $' + value.labelAmount + ' amount'"
              class="donation-starter__button"
              :class="{'is-active': activeValueSingle === value.labelAmount && customValue.singleAmount === '' }"
              role="button"
              @click="activeValueSingle = value.labelAmount; customValue.singleAmount = ''; errors = [];" 
            >
              <span>{{ isFrenchLanguage ? value.labelAmount + ' $' : '$' + value.labelAmount }}</span>
            </button>
          </div>
          <div id="CustomAmountButtons" class="donation-starter__value-container">
            <fieldset class="form__group">
              <div
                class="field field--with-floating-label"
                :class="{'has-value': customValue.singleAmount !== '',
                          'is-active': activeValueSingle === customValue.singleAmount,
                          'french-donation': isFrenchLanguage}"
                :key="customValue.idSingle"
                @click="activeValueSingle = customValue.singleAmount; errors = [];"
              >
                <label
                  :aria-label="otheramounttext"
                  class="field__label"
                  :for="customValue.idSingle"
                >
                  <span>{{ otheramounttext }}</span>
                </label>
                <div class="field__currency">
                  <div>$</div>
                </div>
                <input
                  :id="customValue.idSingle"
                  v-model.trim="customValue.singleAmount"
                  @keyup="activeValueSingle = customValue.singleAmount"
                  @keypress="preventNonNumeric"
                  class="field__input"
                  autocomplete="off"
                  inputmode="decimal"
                  maxlength="8"
                  pattern="\d+(\.\d*)?"
                  type="text"
                >
              </div>
            </fieldset>
          </div>
        </div>
        
        <!-- Donation MONTHLY -->
        <div v-else class="donation-starter__values-wrapper" id="AmountButtonsMo">
          <div v-for="value in values" :key="value.id" class="donation-starter__value-container">
            <button
              :aria-label="isFrenchLanguage ? 'Sélectionner ' + value.labelAmountMo + ' $ par mois' : 'Select $' + value.labelAmountMo + ' per month'"
              class="donation-starter__button"
              :class="{'is-active': activeValueMonthly === value.labelAmountMo && customValue.monthlyAmount === ''}"
              role="button"
              @click="activeValueMonthly = value.labelAmountMo; customValue.monthlyAmount = '';" 
            >
              <span>{{ isFrenchLanguage ? value.labelAmountMo + ' $' : '$' + value.labelAmountMo }}</span>
            </button>
          </div>
          <div id="CustomAmountButtons" class="donation-starter__value-container">
            <fieldset class="form__group">
              <div
                class="field field--with-floating-label monthly-donation"
                :class="{'has-value': customValue.monthlyAmount !== '',
                          'is-active': activeValueMonthly === customValue.monthlyAmount,
                          'french-donation': isFrenchLanguage}"
                :key="customValue.idMonthly"
                @click="activeValueMonthly = customValue.monthlyAmount; errors = [];"
              >
                <label
                  :aria-label="otheramounttext"
                  class="field__label"
                  :for="customValue.idMonthly"
                >
                  <span>{{ otheramounttext }}</span>
                </label>
                <div v-if="isFrenchLanguage" class="field__currency">
                  <div>$/mois</div>
                </div>
                <div v-else class="field__currency">
                  <div>$</div>
                  <div>/mo</div>
                </div>
                <input
                  :id="customValue.idMonthly"
                  v-model.trim="customValue.monthlyAmount"
                  @keyup="activeValueMonthly = customValue.monthlyAmount"
                  @keypress="preventNonNumeric"
                  class="field__input"
                  autocomplete="off"
                  inputmode="decimal"
                  maxlength="8"
                  pattern="\d+(\.\d*)?"
                  type="text"
                >
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      
      <!-- Error messages -->
      <div v-if="errors.length" class="donation-starter__error">
        <div class="field__error theme theme--light-grey" v-for="(error, index) in errors" :key="index">
          {{ error }}
        </div>
      </div>
      
      <div class="donation-starter__submit">
        <div 
          :aria-label="submitButtonCta"
          class="btn btn--blue"
          @click="goToDonationForm();"
          role="button"
          tabindex="0"
        >
          <span class="btn__content">
            <span class="btn__text">{{ submitButtonCta }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
